import React, {useCallback, useEffect, useRef, useState} from 'react';
import {clsx} from 'clsx';
import IMG from "../../../constants/image";
import ImageBasic from "../Image/ImageBasic";
import {useClickOutside} from "../../../hooks/useClickOutside";
import popupStore from "../../../store/popupStore";
import appStore from "../../../store/appStore";

const MobileModal = () => {
    const {isOpenMobile, data, setPopupMobile} = popupStore() || {}
    const {setActiveTabConfirm} = appStore()
    const {
        children,
        animationClass = 'animate-slideInUp',
        closeAnimationClass = 'animate-slideOutDown',
        modalStyle = {},
        height = 'h-[80%]',
        top = 'top-[20%]',
        hideCloseButton = false,
        bgClass = 'bg-[#FAFAFC]'
    } = data || {}
    const modalRef = useRef(null);
    const timerRef = useRef(null);
    const [isClosing, setIsClosing] = useState(false);
    const [visible, setVisible] = useState(false);
    const [currentHeight, setCurrentHeight] = useState(height);
    const [currentTop, setCurrentTop] = useState(top);

    // Store current position values when opening
    useEffect(() => {
        if (isOpenMobile) {
            setCurrentHeight(height);
            setCurrentTop(top);
        }
    }, [isOpenMobile, height, top]);

    //handle height top popup
    useEffect(() => {

    }, [height, top])
    // Handle opening
    useEffect(() => {
        if (isOpenMobile) {
            setIsClosing(false);
            setVisible(true);
        }
    }, [isOpenMobile]);

    // Handle closing
    useEffect(() => {
        if (!isOpenMobile && visible) {
            setIsClosing(true);
            timerRef.current = setTimeout(() => {
                setVisible(false);
                clearTimeout(timerRef.current);
            }, 300);
        }
        return () => {
            if (timerRef.current)
                clearTimeout(timerRef.current);
        }
    }, [isOpenMobile, visible]);

    // Memoize the close handler
    const handleClose = useCallback(() => {
        // Don't reset position values when closing
        setPopupMobile && setPopupMobile({
            isOpenMobile: false,
            data: {
                ...data,
                height: currentHeight,
                top: currentTop
            } // Keep current position data
        });
        setActiveTabConfirm('pickup');
    }, [setPopupMobile, setActiveTabConfirm, data, currentHeight, currentTop]);

    useClickOutside({
        ref: modalRef,
        setOutside: () => {
            if (!isClosing) handleClose()
        }
    });

    if (!visible && !isOpenMobile) return null;
    return (
        <div>
            {/* Overlay */}
            <div
                className={clsx(
                    "fixed inset-0 bg-black bg-opacity-50 z-10",
                    isClosing ? "animate-fadeOut" : "animate-fadeIn"
                )}
                onClick={handleClose}
            />

            {/* Modal */}
            <div
                ref={modalRef}
                style={modalStyle}
                className={clsx(
                    "fixed left-0 right-0 z-10 overflow-y-scroll rounded-t-3xl shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]",
                    isClosing ? closeAnimationClass : animationClass,
                    currentHeight,
                    currentTop,
                    bgClass
                )}
            >
                {!hideCloseButton && (
                    <ImageBasic
                        src={IMG.icon.close}
                        onClick={handleClose}
                        alt="close"
                        className="absolute w-6 h-6 top-5 right-4 cursor-pointer"
                    />
                )}
                {children}
            </div>
        </div>
    );
};

export default MobileModal;